import React from "react";
import { showValidation } from "./utilities/showValidation";
import { showLabel } from "./utilities/showLabel";

const labelField = (props) => {
  let { formId, field } = props;
  let { element } = field;

  return (
    <div className="field-style" style={{ paddingBlockEnd: "0px" }}>
      {showLabel(field, formId)}
    </div>
  );
};

export default labelField;



// WEBPACK FOOTER //
// ./src/libraries/form/formField/fields/labelfield.jsx